import { Helmet } from 'react-helmet-async';

import HistoryEduIcon from '@mui/icons-material/HistoryEdu';

import { useMissionAccess } from '../../components/Access/hooks/useMissionAccess.hook';
import {
  PATH_MISSION_DEFAULT,
  PATH_MISSION_REPORTS,
  PATH_MISSION_REPORTS_INIT,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';
import { Loading } from '../../components/Loading';
import { SpeedDial } from '../../components/SpeedDial';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { MissionContextStatus } from '../../contexts/MissionContext/types/mission-context.type';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { ReportsWithinAMission } from './ReportsWithinAMission';

export const MissionReportsPage = () => {
  const missionContext = useMissionContext();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();
  const missionWording = useMissionSpaceWording();

  const { folderId, missionId } = missionContext;
  const access = useMissionAccess(missionId);

  const { paths: missionPaths } = useBuildPaths(
    {
      default: PATH_MISSION_DEFAULT,
      reports: PATH_MISSION_REPORTS,
      initReport: PATH_MISSION_REPORTS_INIT,
    },
    { folderId, missionId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            `Liste des Rapports ${missionWording.ofName}`,
            missionContext.mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          ...missionBreadcrumbPaths,
          { to: missionPaths.reports, label: 'rapports', key: 'reports' },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle title={`Liste des Rapports ${missionWording.ofName}`} />
  );

  if (missionContext.status !== MissionContextStatus.Ready) {
    return (
      <>
        <Loading />
        {beforeTitleContent}
        {titleContent}
      </>
    );
  }

  return (
    <>
      {beforeTitleContent}
      {titleContent}

      <ReportsWithinAMission />

      <SpeedDial
        actions={[
          {
            id: 'createReport',
            gate: access.initReport,
            icon: <HistoryEduIcon />,
            name: 'Initialiser Rapport',
            to: missionPaths.initReport,
          },
        ]}
        title="Actions possibles sur les Rapports"
      />
    </>
  );
};
